<app-modal
  header="Privacy Policy"
  [(visible)]="visible"
  (visibleChange)="change($event)"
  (onShow)="show()"
  (onHide)="hide()">
  <app-privacy-policy></app-privacy-policy>
</app-modal>